<section class="hd-cycles-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-cycles-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-cycles-cheat-sheet-page__controls" aria-label="Cycles cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-cycles-cheat-sheet-page__divider"></span>

      <!-- Print (zelfde control als de PHS cheat sheet) -->
      <button type="button" class="hd-cycles-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-cycles-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }

  <div class="hd-cycles-cheat-sheet-page__deck">
    <div class="hd-cycles-cheat-sheet-page__grid">

      <!-- Rij 1: main keynotes (Persoonlijk / Educatief / Omgevend) -->
      @for (card of keynoteCards(); track card.key) {
        <article class="cycles-card" [style.--card-color]="card.color">
          <header class="cycles-card__header">
            <i class="fas fa-{{ card.faIcon }} cycles-card__icon" aria-hidden="true"></i>
            <div class="cycles-card__heading">
              <h3 class="cycles-card__title">{{ card.title }}</h3>
              <p class="cycles-card__subtitle">
                {{ bringsLabel() }} <span class="cycles-card__brings" [innerHTML]="card.brings"></span>
              </p>
            </div>
          </header>
          <div class="cycles-card__body">
            <ul class="cycles-card__bullets">
              @for (bullet of card.bullets; track $index) {
                <li [innerHTML]="bullet"></li>
              }
            </ul>
          </div>
        </article>
      }

      <!-- Rij 2: planeet-groep-banden (Richting / Mensen / Ontwikkeling) -->
      @for (group of planetGroups(); track group.key) {
        <article class="cycles-band">
          <i class="fas fa-{{ group.faIcon }} cycles-band__icon" aria-hidden="true"></i>
          <h3 class="cycles-band__title">{{ group.title }}</h3>
          <span class="cycles-band__glyphs" aria-hidden="true">
            @for (glyph of group.glyphs; track $index) {
              <span class="cycles-band__glyph">{{ glyph }}</span>
            }
          </span>
        </article>
      }

      <!-- Rij 3: Tegenkoming -vs- Vernieuwing + niet-zelf center thema's -->
      <article class="cycles-panel cycles-panel--encounter">
        <header class="cycles-panel__header">
          <i class="fas fa-{{ encounterRenewalIcon }} cycles-panel__icon" aria-hidden="true"></i>
          <h3 class="cycles-panel__title">{{ encounterRenewal().title }}</h3>
        </header>
        <div class="cycles-panel__cols cycles-panel__cols--two">
          <p class="cycles-panel__text">{{ encounterRenewal().encounter }}</p>
          <p class="cycles-panel__text">{{ encounterRenewal().renewal }}</p>
        </div>
      </article>

      <article class="cycles-panel cycles-panel--centers is-wide">
        <header class="cycles-panel__header">
          <i class="fas fa-{{ centerConditioningIcon }} cycles-panel__icon" aria-hidden="true"></i>
          <h3 class="cycles-panel__title">{{ centerConditioningTitle() }}</h3>
        </header>
        <div class="cycles-panel__cols cycles-panel__cols--three">
          @for (column of centerColumns(); track $index) {
            <div class="cycles-panel__col">
              @for (item of column; track item.center) {
                <div class="center-theme">
                  <span class="center-theme__shape" [innerHTML]="item.shape" aria-hidden="true"></span>
                  <p class="center-theme__text">
                    <span class="center-theme__label">{{ item.label }}</span>: <span [innerHTML]="item.text"></span>
                  </p>
                </div>
              }
            </div>
          }
        </div>
      </article>

      <!-- Rijen 4-6: returns + info-kaarten -->
      @for (card of returnCards(); track card.key) {
        <article class="cycles-card cycles-card--dark" [class.is-wide]="card.wide">
          <header class="cycles-card__header">
            @if (card.glyph) {
              <span class="cycles-card__glyph" aria-hidden="true">{{ card.glyph }}</span>
            } @else if (card.faIcon) {
              <i class="fas fa-{{ card.faIcon }} cycles-card__icon" aria-hidden="true"></i>
            }
            <div class="cycles-card__heading">
              <h3 class="cycles-card__title">{{ card.title }}</h3>
              <p class="cycles-card__subtitle">{{ card.subtitle }}</p>
            </div>
          </header>
          <div class="cycles-card__body" [class.cycles-card__body--two-cols]="card.bullets2.length > 0">
            <ul class="cycles-card__bullets">
              @for (bullet of card.bullets; track $index) {
                <li [innerHTML]="bullet"></li>
              }
            </ul>
            @if (card.bullets2.length > 0) {
              <ul class="cycles-card__bullets">
                @for (bullet of card.bullets2; track $index) {
                  <li [innerHTML]="bullet"></li>
                }
              </ul>
            }
          </div>
        </article>
      }
    </div>
  </div>
</section>
